import React, { createContext, useContext, useState, useCallback } from 'react';

const ContactPreviewContext = createContext(null);

export function ContactPreviewProvider({ children }) {
  const [previewId, setPreviewId] = useState(null);

  const openPreview  = useCallback((id) => setPreviewId(id), []);
  const closePreview = useCallback(() => setPreviewId(null), []);

  return (
    <ContactPreviewContext.Provider value={{ previewId, openPreview, closePreview }}>
      {children}
    </ContactPreviewContext.Provider>
  );
}

export function useContactPreview() {
  const ctx = useContext(ContactPreviewContext);
  if (!ctx) throw new Error('useContactPreview must be used inside ContactPreviewProvider');
  return ctx;
}
